export default __webpack_public_path__ + "static/media/Background_00089.14f75150.png";